import request from '@/utils/request'

/* 证件状态统计 */
export function LicenseStateSummary() {
  return request({
    url: '/admin/v1/vehicle/carLicenseManage/summary',
    method: 'POST',
  })
}
/* 违章数量统计 */
export function ViolationSummary(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/summary',
    method: 'POST',
    data,
  })
}
/* 证件列表 */
export function licenseList(data) {
  return request({
    url: '/admin/v1/vehicle/carLicenseManage/list',
    method: 'POST',
    data,
  })
}
/* 违章列表 */
export function ViolationList(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/status',
    method: 'POST',
    data,
  })
}
/* 违章明细 */
export function ViolationDetail(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/detail',
    method: 'POST',
    data,
  })
}
/* 违章记录删除 */
export function ViolationsDelte(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/detail/delete',
    method: 'POST',
    data,
  })
}
/* 批量导入违章 */
export function violationExcel(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/entranceExcel',
    method: 'POST',
    data,
  })
}
/* 批量导入保单 */
export function insuranceExcel(data) {
  return request({
    url: '/admin/v1/vehicle/routines/insurance/entranceExcel',
    method: 'POST',
    data,
  })
}
/* 新增违章 */
export function ViolationAdd(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/add',
    method: 'POST',
    data,
  })
}
export function ViolationUpdate(data) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/updateState',
    method: 'POST',
    data,
  })
}
/* 车险过期状态统计 */
export function insuranceSummary(data) {
  return request({
    url: '/admin/v1/vehicle/routines/insuranceState/summary',
    method: 'POST',
    data,
  })
}
/* 车险列表 */
export function insuranceList(data) {
  return request({
    url: '/admin/v1/vehicle/routines/insurance/list',
    method: 'POST',
    data,
  })
}
/* 保单列表 */
export function policyList(data) {
  return request({
    url: '/admin/v1/vehicle/routines/insurance/detailList',
    method: 'POST',
    data,
  })
}
/* 保单编辑 */
export function policyEdit(data) {
  return request({
    url: '/admin/v1/vehicle/routines/insurance/edit',
    method: 'POST',
    data,
  })
}
/* 保单新增 */
export function policyAdd(data) {
  return request({
    url: '/admin/v1/vehicle/routines/insurance/add',
    method: 'POST',
    data,
  })
}
/* 保单删除列表 */
export function policyDelte(data) {
  return request({
    url: '/admin/v1/vehicle/routines/insurance/delete',
    method: 'POST',
    data,
  })
}
/* 维保管理查询列表 */
export function maintenanceList(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/list',
    method: 'POST',
    data,
  })
}
/* 维保详情列表 */
export function maintenanceDetail(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/detail',
    method: 'POST',
    data,
  })
}
/* 新增维保 */
export function maintenanceAddSignCheck(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/v2/add',
    method: 'POST',
    data,
    signParams: ['contractId', 'totalAmount', 'customerAmount', 'floatAmount'],
  })
}
/* 编辑维保 */
export function maintenanceEditSignCheck(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/v2/edit',
    method: 'POST',
    data,
    signParams: ['id', 'totalAmount', 'customerAmount', 'floatAmount'],
  })
}
/* 事故管理查询列表 */
export function accidentList(data) {
  return request({
    url: '/admin/v1/vehicle/routines/accident/list',
    method: 'POST',
    data,
  })
}

/* 事故管理详情列表 */
export function accidentDestail(data) {
  return request({
    url: '/admin/v1/vehicle/routines/accident/detail',
    method: 'POST',
    data,
  })
}

/* 事故管理编辑 */
export function accidentEditSignCheck(data) {
  return request({
    url: '/admin/v1/vehicle/routines/accident/v2/edit',
    method: 'POST',
    data,
    signParams: ['contractId', 'lossAmount', 'receivableAmount'],
  })
}

/* 新增事故 */
export function accidentAddSignCheck(data) {
  return request({
    url: '/admin/v1/vehicle/routines/accident/v2/add',
    method: 'POST',
    data,
    signParams: ['contractId', 'lossAmount', 'receivableAmount'],
  })
}

/* 根据维保类型查询支付项 */
export function queryByType(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/pay/queryByType',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取车型
 * @apiUrl
 */
export function getCarModelList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/modelIdAndName',
    method: 'POST',
    data,
  })
}

/* 获取维保历史列表 */
export function maintenanceHistoryList(data) {
  return request({
    url: '/admin/v1/vehicle/uploadTask/getPage',
    method: 'POST',
    data,
  })
}
/* 获取维保历史详情 */
export function maintenanceHistoryDetail(data) {
  return request({
    url: '/admin/v1/vehicle/uploadTask/getDetail',
    method: 'POST',
    data,
  })
}

/* 违章配置创建 */
export function configSaveViolationConfig(data) {
  return request({
    url: '/admin/v1/vehicle/config/saveViolationConfig',
    method: 'POST',
    data,
  })
}

// 违章配置读取接口
export function getByType(data) {
  return request({
    url: '/admin/v1/vehicle/config/getByType',
    method: 'POST',
    data,
  })
}

// 相关信息查询
export function getOrderOnTime(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/getOrderOnTime',
    method: 'POST',
    data,
  })
}

// <--------------------------------------------------------维保一期------------------------------------------------->
// 维保方案列表
export function maintenancePlanList(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/plan/list',
    method: 'POST',
    data,
  })
}

// 维保方案详情
export function maintenancePlanDetail(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/plan/detail',
    method: 'POST',
    data,
  })
}

// 发起维保
export function initiateMaintenance(data) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/launch',
    method: 'POST',
    data,
  })
}

// 查询异步任务状态
export function getAsyncTaskStatus(data) {
  return request({
    url: '/admin/v1/vehicle/async/export/check/state',
    method: 'POST',
    data,
  })
}

// 保单附件下载
export function downloadPolicy(data) {
  return request({
    url: '/admin/v1/vehicle/routines/insuranceAttachment/export',
    method: 'POST',
    data,
  })
}
